const getSearchImageObj = (result) => {
  const returnCustomImage = (result?.category?.raw === 'TV Guide') && result?.customImage
  return (
    returnCustomImage ? JSON.parse(result?.customImage?.raw) : {
      _renditions: {
        '99x56': result?.image?.raw,
        '225x127': result?.image?.raw,
      },
    }
  )
}

export default getSearchImageObj
